import { useSelector } from 'react-redux';
import _isNil from 'lodash/isNil';
import { RootState } from '../../store';

import { getValueAtKeyInNestedObject } from '../common';
import { useEffect } from 'react';

const rtlLangList = ['ur'];

export function useGetSiteConstantValue() {
  const { commonDataReducer } = useSelector((state: RootState) => state);

  const { siteConstant = {}, currLang } = commonDataReducer;

  useEffect(() => {
    const bodyEle = document.querySelector('body');

    if (!_isNil(currLang) && !_isNil(bodyEle)) {
      if (rtlLangList.includes(currLang.value)) {
        bodyEle.setAttribute('dir', 'rtl');
      } else {
        bodyEle.setAttribute('dir', 'ltr');
      }
    }
  }, [currLang]);

  const getSiteConstantValue = (root: string, keyName: string): string => {
    const obj = siteConstant[root] ?? {};

    return (getValueAtKeyInNestedObject(obj, keyName) ?? '') as unknown as string;
  };

  return { getSiteConstantValue };
}
